module.exports = __webpack_public_path__ + "static/media/cuttingRope-dark.39241365.png";